/**
 * @class ProductFile
 */
export default class ProductFile {
    /**
     * @param {Number}          id
     * @param {String}          name
     * @param {String}          path
     * @param {String}          mimeType
     * @param {Number}          fileType
     * @param {String | null}   moreInfo
     * @param {String | null}   url
     * @param {Number}          numberOfPages
     * @param {Number}          numberOfPagesOnline
     * @param {String}          uploaded
     */
    constructor(id, name, path, mimeType, fileType, moreInfo, url, numberOfPages, numberOfPagesOnline, uploaded) {
        this._id = id;
        this._name = name;
        this._path = path;
        this._mimeType = mimeType;
        this._fileType = fileType;
        this._moreInfo = moreInfo;
        this._url = url;
        this._numberOfPages = numberOfPages;
        this._numberOfPagesOnline = numberOfPagesOnline;
        this._uploaded = new Date(uploaded);

        if (typeof this._id !== "number") {
            throw new Error("Invalid datatype of ID - ProductFile");
        }
    }

    /**
     * @return {Number}
     */
    get id() {
        return this._id;
    }

    /**
     * @param {Number} id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @return {String}
     */
    get name() {
        return this._name;
    }

    /**
     * @param {String} name
     */
    set name(name) {
        this._name = name;
    }

    /**
     * @return {String}
     */
    get path() {
        return this._path;
    }

    /**
     * @param {String} path
     */
    set path(path) {
        this._path = path;
    }

    /**
     * @return {String}
     */
    get mimeType() {
        return this._mimeType;
    }

    /**
     * @param {String} mimeType
     */
    set mimeType(mimeType) {
        this._mimeType = mimeType;
    }

    /**
     * @return {Number}
     */
    get fileType() {
        return this._fileType;
    }

    /**
     * @param {Number} fileType
     */
    set fileType(fileType) {
        this._fileType = fileType;
    }

    /**
     * @return {String | null}
     */
    get moreInfo() {
        return this._moreInfo;
    }

    /**
     * @param {String | null}   moreInfo
     */
    set moreInfo(moreInfo) {
        this._moreInfo = moreInfo;
    }

    /**
     * @return {String | null}
     */
    get url() {
        return this._url;
    }

    /**
     * @param {String | null}   url
     */
    set url(url) {
        this._url = url;
    }

    /**
     * @return {Number}
     */
    get numberOfPages() {
        return this._numberOfPages;
    }

    /**
     * @param {Number} numberOfPages
     */
    set numberOfPages(numberOfPages) {
        this._numberOfPages = numberOfPages;
    }

    /**
     * @return {Number}
     */
    get numberOfPagesOnline() {
        return this._numberOfPagesOnline;
    }

    /**
     * @param {Number} numberOfPagesOnline
     */
    set numberOfPagesOnline(numberOfPagesOnline) {
        this._numberOfPagesOnline = numberOfPagesOnline;
    }

    /**
     * @return {Object}
     */
    get uploaded() {
        return this._uploaded;
    }

    /**
     * @param {Object} uploaded
     */
    set uploaded(uploaded) {
        this._uploaded = uploaded;
    }

    /**
     * @return {Object}
     */
    clone() {
        return new ProductFile(
            this._id,
            this._name,
            this._path,
            this._mimeType,
            this._fileType,
            this._moreInfo,
            this._url,
            this._numberOfPages,
            this._numberOfPagesOnline,
            this._uploaded.toString()
        );
    }

    /**
     * @return  {Boolean}
     */
    isOnline = () => {
        return this._url !== null;
    };

    /**
     * @param {Boolean} online
     * @return {Number}
     */
    getNumberOfPages = (online) => {
        if (online) {
            return this._numberOfPagesOnline;
        }

        return this._numberOfPages;
    };

    /**
     * Clones product file object and updates page property.
     *
     * @param   {Number}    numberOfPages
     * @return  {Object}
     */
    updateNumberOfPages = (numberOfPages) => {
        let productFile = this.clone();
        productFile.numberOfPages = numberOfPages;

        return productFile;
    };

    /**
     * Clones product file object and updates online page property.
     *
     * @param   {Number}    numberOfPagesOnline
     * @return  {Object}
     */
    updateNumberOfPagesOnline = (numberOfPagesOnline) => {
        let productFile = this.clone();
        productFile.numberOfPagesOnline = numberOfPagesOnline;

        return productFile;
    };
}
